<div class="page-container">
  <p-card>
    <ng-template pTemplate="header">
      <div class="p-3">
        <h2 class="m-0">
          <i class="pi pi-upload mr-2"></i>Upload Fuel Report
        </h2>
        <p class="text-color-secondary mt-1 mb-0">
          Import fuel records from a generated Excel report. Rows with vendor <strong>YARD</strong> are automatically excluded.
        </p>
      </div>
    </ng-template>

    <!-- Drop Zone -->
    <div
      class="drop-zone"
      [class.dragging]="isDragging"
      [class.has-file]="selectedFile"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="fileInput.click()">

      <input
        #fileInput
        type="file"
        accept=".xlsx,.xls"
        class="hidden-input"
        (change)="onFileSelected($event)" />

      <ng-container *ngIf="!selectedFile">
        <i class="pi pi-file-excel drop-icon"></i>
        <p class="drop-text">Drag &amp; drop an Excel file here, or click to browse</p>
        <p class="drop-hint">Accepts <code>.xlsx</code> and <code>.xls</code> files</p>
      </ng-container>

      <ng-container *ngIf="selectedFile">
        <i class="pi pi-file-excel drop-icon selected"></i>
        <p class="drop-text file-name">{{ selectedFile.name }}</p>
        <p class="drop-hint">{{ formatBytes(selectedFile.size) }}</p>
      </ng-container>
    </div>

    <!-- Actions -->
    <div class="flex gap-2 justify-content-end mt-3" *ngIf="selectedFile">
      <button
        type="button"
        class="p-button p-button-secondary p-button-outlined"
        (click)="clearFile()"
        [disabled]="isUploading">
        <i class="pi pi-times mr-2"></i>Clear
      </button>
      <button
        type="button"
        class="p-button"
        (click)="onUpload()"
        [disabled]="isUploading">
        <i [class]="isUploading ? 'pi pi-spin pi-spinner mr-2' : 'pi pi-upload mr-2'"></i>
        {{ isUploading ? 'Uploading...' : 'Upload' }}
      </button>
    </div>

    <!-- Results -->
    <div class="results-section" *ngIf="uploadResult">
      <h3 class="section-title">Import Summary</h3>

      <div class="stats-grid">
        <div class="stat-card stat-total">
          <span class="stat-value">{{ uploadResult.total_rows }}</span>
          <span class="stat-label">Total Rows</span>
        </div>
        <div class="stat-card stat-success">
          <span class="stat-value">{{ uploadResult.inserted }}</span>
          <span class="stat-label">Imported</span>
        </div>
        <div class="stat-card stat-yard">
          <span class="stat-value">{{ uploadResult.skipped_yard }}</span>
          <span class="stat-label">Skipped (YARD)</span>
        </div>
        <div class="stat-card stat-dupe">
          <span class="stat-value">{{ uploadResult.skipped_duplicate }}</span>
          <span class="stat-label">Duplicates</span>
        </div>
        <div class="stat-card stat-error" *ngIf="uploadResult.errors > 0">
          <span class="stat-value">{{ uploadResult.errors }}</span>
          <span class="stat-label">Errors</span>
        </div>
      </div>

      <div class="error-list" *ngIf="uploadResult.error_details?.length">
        <h4 class="error-title"><i class="pi pi-exclamation-triangle mr-2"></i>Row Errors</h4>
        <ul class="error-items">
          <li *ngFor="let err of uploadResult.error_details">{{ err }}</li>
        </ul>
      </div>
    </div>
  </p-card>
</div>
